<template>
  <div id="container"></div>
</template>
<script>
import AMapLoader from "@amap/amap-jsapi-loader";

export default {
  name: "MapContainer",
  mounted() {
    this.initAMap();
  },
  unmounted() {
    this.map?.destroy();
  },
  methods: {
    initAMap() {
      window._AMapSecurityConfig = {
        securityJsCode: "042be3f88e7f4068df4f7940126ed2c1",
      };
      AMapLoader.load({
        key: "92431fe55a5f701ff4feb8095c03aef3", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Scale"], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
      })
        .then((AMap) => {
          this.map = new AMap.Map("container", {
            viewMode: "2D", // 是否为3D地图模式
            zoom: 16, // 初始化地图级别
            center: [113.899124, 22.793822], // 初始化地图中心点位置
          });
           // 添加标记
           const infoWindow = new AMap.InfoWindow({
            content: '<div style="color: black;">广东省深圳市光明区公明街道上村社区长春北路1A栋301</div>', // 信息窗口的内容
            offset: new AMap.Pixel(72, -30) // 信息窗口相对于标记的位置
          });
          const marker = new AMap.Marker({
            position: [113.899124, 22.793822], // 标记的位置
            title: "广东省深圳市光明区公明街道上村社区长春北路1A栋301", // 鼠标悬停时的提示
            content: '<div style="color: red;width:10vw">📍</div>', // 自定义标记内容
          });
          // 将标记添加到地图
          marker.setMap(this.map);
          // 添加点击事件，打开信息窗口
          marker.on('click', () => {
            infoWindow.open(this.map, marker.getPosition());
          });
          infoWindow.open(this.map, marker.getPosition());
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
<style scoped>
#container {
  height: 100%;
}
</style>
